<template>
    <div class="separator-red">
        <div></div>
    </div>
</template>
<script>
export default {
    name: 'SeparatorRed',
    components: {},
    data() {
        return {
        }
    },
    computed: {},
    methods: {}
}
</script>